
import {Component, Vue, Watch} from "vue-property-decorator";
import {pad2, CountdownParts, renewalProductKeyForPath, RenewalProductKey} from "@/utils/renewalOffer";
import {DemoStatus, demoBarBaslik, demoBarVisible, demoCountdownParts} from "@/utils/demoStatus";

/**
 * Demo hesaplar için app-bar'ın hemen altına yapışık geri sayım şeridi.
 *
 * Yenileme barından (RenewalCountdownBar) farkları:
 *  - Kademe yok: demo süresi BOYUNCA görünür.
 *  - Kapatılamaz; demo bittiğinde de kaybolmaz, "Demo süreniz doldu" der.
 *  - CTA "Hemen Al": mağazadaki ilgili ürünün fiyatlandırma sayfasına
 *    otomatik girişli götürür (bkz. store/startDemoPurchase).
 *
 * Ürün ayrımı $route.path üzerinden REAKTİF yapılır; store'daki
 * isIcraPro/isEicraPro getter'ları window.location kullandığı için reaktif değil.
 */
@Component
export default class DemoCountdownBar extends Vue {
  loading = false;
  parts: CountdownParts = {gun: 0, saat: 0, dakika: 0, saniye: 0, bitti: false};
  private intervalId: number | null = null;

  get productKey(): RenewalProductKey {
    return renewalProductKeyForPath(this.$route.path);
  }

  // Kullanıcının bulunduğu ürünün demo durumu (İcraProWeb / e-İcraPro ayrı).
  get status(): DemoStatus | null {
    return this.$store.getters.demoStatusFor(this.productKey);
  }

  get visible(): boolean {
    return demoBarVisible(this.status);
  }

  get sayacAktif(): boolean {
    return !this.parts.bitti;
  }

  get baslik(): string {
    return demoBarBaslik(this.status);
  }

  get altBaslik(): string {
    return this.sayacAktif
        ? 'Kesintisiz devam etmek için paketinizi seçin'
        : 'Kaldığınız yerden devam etmek için paketinizi seçin';
  }

  get ariaLabel(): string {
    return `Demo süresinin bitmesine kalan: ${this.parts.gun} gün ${this.parts.saat} saat ${this.parts.dakika} dakika`;
  }

  created() {
    this.tick();
    // Saniye hassasiyeti için 1 sn'de bir; sekme arkada olsa da düzeltilir.
    this.intervalId = window.setInterval(this.tick, 1000);
  }

  beforeDestroy() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }

  // Ürün veya durum değişince aktif ürünün geri sayımına anında geç.
  @Watch('status')
  onStatusChange() {
    this.tick();
  }

  tick() {
    this.parts = demoCountdownParts(this.status);
  }

  pad(n: number): string {
    return pad2(n);
  }

  async onSatinAl() {
    this.loading = true;
    try {
      await this.$store.dispatch('startDemoPurchase', this.productKey);
    } finally {
      this.loading = false;
    }
  }
}
